import { Schema } from 'effect';

import { FacetKey } from './facetKey';

export const FacetOption = Schema.Struct({
  value: Schema.String,
  label: Schema.String,
  count: Schema.NullOr(Schema.Int),
  selected: Schema.Boolean,
  searchText: Schema.optionalKey(Schema.String),
});

export type FacetOption = typeof FacetOption.Type;

export const Facet = Schema.TaggedUnion({
  Terms: {
    key: FacetKey,
    name: Schema.NullOr(Schema.String),
    unit: Schema.NullOr(Schema.String),
    options: Schema.Array(FacetOption),
    valueType: Schema.optionalKey(Schema.Literals(['string', 'boolean'])),
  },
  Range: {
    key: FacetKey,
    name: Schema.NullOr(Schema.String),
    unit: Schema.NullOr(Schema.String),
    valueType: Schema.optionalKey(Schema.Literals(['integer', 'float'])),
    bounds: Schema.Struct({ min: Schema.Finite, max: Schema.Finite }),
    /**
     * The distinct values the scope holds, ascending. Empty where the backend
     * answers the bounds alone, as it does for the price.
     */
    values: Schema.Array(Schema.Finite),
    selected: Schema.Struct({
      min: Schema.NullOr(Schema.Finite),
      max: Schema.NullOr(Schema.Finite),
    }),
  },
});

export type Facet = typeof Facet.Type;

export const FacetSet = Schema.Struct({
  facets: Schema.Array(Facet),
  total: Schema.Int,
});

export type FacetSet = typeof FacetSet.Type;
